module.exports = "<p>Rotate device to portrait</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/message-overlay/message-overlay.component.html
// module id = ./src/app/message-overlay/message-overlay.component.html
// module chunks = main